// extracted by mini-css-extract-plugin
export default {"content":"style_content__amegY","itemName":"style_itemName__k+MKE"};